  let tipos_fecha = Object.freeze({
    INGRESO:'INGRESO',
    ANTIGUEDAD:'ANTIGUEDAD',
    list: [
        {value: 'INGRESO', text: 'INGRESO'},
        {value: 'ANTIGUEDAD', text: 'ANTIGUEDAD'},
    ]
  });

  let tipos_salario = Object.freeze({
    DIARIO: 'DIARIO',
    INTEGRADO: 'INTEGRADO',
    list: [
        {value: 'DIARIO', text: 'Salario diario'},
        {value: 'INTEGRADO', text: 'Salario integrado'},
    ]
  });
  
  module.exports = { tipos_fecha, tipos_salario }